import React, { useEffect, useRef }  from 'react';
import { StyledNumberCell } from './StyledNumberCell';
import { gsap } from "gsap";

import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);


const NumberCell = ({ bigNumber, size, title, text, isImage, image, isColumn, newHome }) => {

  const columnClass = isColumn ? "is-column" : "";
  const imageBg = useRef(null);

  useEffect(() => {
    if(imageBg.current)
    gsap.to(imageBg.current, {
      duration: .75,
      ease: "power2.easeInOut",
      scale: 1.1,
      scrollTrigger: {
        trigger: imageBg.current,
        start: "top center"
      }
    })
  }, [imageBg])
  return (
    <React.Fragment>
      {
        <StyledNumberCell newHome={newHome} className={ isImage ? `${columnClass} number--cell-flex-is-image` : `${columnClass} `}>
          {
            isImage ?
            <div className="number--cell-flex number--cell-flex-img">
              <div className="number--cell-img">
                <div className="number--cell-img-mask">
                  <img ref={imageBg} src={image} />
                </div>
              </div>
            </div>
            :
            <div className="number--cell-flex number--cell-flex-text">
              <h2 className={newHome ? "big--title " : "big--title primary-green"}>
                {bigNumber}
                <span className="number--size">{size}</span>
              </h2>
              <h5 className="big--title ">
                {title}
              </h5>
              <p className={newHome ? "preset-10" : "preset-10 grey-700"} >{text}</p>
            </div>

          }
          
        </StyledNumberCell>
          
      }
    </React.Fragment>
  );
};

export default NumberCell;
